import { Box, Typography } from '@mui/material';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs';

export function TaxInfoTooltipContent() {
  const { t } = useTranslate();
  const { maxTaxResidencySelection } = useAppSelector(selectConfigsState);

  return (
    <Box margin={1}>
      <Typography variant="body2">
        {t('taxInfoDrawer.tooltip.description')}
      </Typography>
      <Typography variant="body2" mt={1}>
        {t('taxInfoDrawer.tooltip.countryLimit', {
          count: maxTaxResidencySelection,
        })}
      </Typography>
      <Typography variant="body2" mt={1}>
        {t('taxInfoDrawer.tooltip.advisorNote')}
      </Typography>
    </Box>
  );
}
